"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorTAction = exports.PaymentErrorStatus = exports.ErrorType = exports.CustomError = void 0;
class CustomError {
    constructor(message, status = 500, additionalInfo = undefined, errorType = ErrorType.Unknown) {
        this.message = message;
        this.status = status;
        this.additionalInfo = additionalInfo;
        this.type = errorType;
    }
}
exports.CustomError = CustomError;
var ErrorType;
(function (ErrorType) {
    ErrorType["UserExist"] = "UserExist";
    ErrorType["NoUserFound"] = "NoUserFound";
    ErrorType["SignUpFailed"] = "SignUpFailed";
    ErrorType["Unknown"] = "Unknown";
    ErrorType["InsufficientFund"] = "InsufficientFund ";
    ErrorType["LoginFailed"] = "loginFailed";
    ErrorType["OPTSendFailed"] = "OPTSendFailed";
    ErrorType["OTPExpired"] = "OTPExpired";
    ErrorType["MobileNumberMissing"] = "MobileNumberMissing";
    ErrorType["InvalidOTPCode"] = "InvalidOTPCode";
    ErrorType["ConfirmVerificationFailed"] = "ConfirmVerificationFailed";
    ErrorType["RequestOPTCodeFailed"] = "RequestOPTCodeFailed";
    ErrorType["CookiesAuthFailed"] = "CookiesAuthFailed";
    ErrorType["UnAuthorized"] = "UnAuthorized";
    ErrorType["TokenVerificationError"] = "TokenVerificationError";
    ErrorType["TokenExpired"] = "TokenExpired";
    ErrorType["OrderPaymentFailed"] = "OrderPaymentFailed";
    ErrorType["OrderPaymentError"] = "OrderPaymentError";
    ErrorType["CantVerifyOrderPayment"] = "CantVerifyOrderPayment";
    ErrorType["PaidAmountNotMatch"] = "PaidAmountNotMatch";
    ErrorType["UpdateGasSupplyFailed"] = "UpdateGasSupplyFailed";
    ErrorType["AmountNotMatch"] = "AmountNotMatch";
    ErrorType["InvalidPaymentGateway"] = "InvalidPaymentGateway";
    ErrorType["PaymentGatewayError"] = "PaymentGatewayError";
    ErrorType["AmountMissing"] = "AmountMissing";
    //----wallet----
    ErrorType["WalletNotFound"] = "WalletNotFound";
    ///----project----
    ////_-----PICKUP---/////
    ErrorType["OrderPickedUpAlready"] = "OrderPickedUpAlready";
    ErrorType["InvalidPickupCode"] = "InvalidPickupCode";
})(ErrorType || (exports.ErrorType = ErrorType = {}));
var PaymentErrorStatus;
(function (PaymentErrorStatus) {
    PaymentErrorStatus["New"] = "New";
    PaymentErrorStatus["Active"] = "Active";
    PaymentErrorStatus["Seen"] = "Seen";
    PaymentErrorStatus["InProgress"] = "InProgress";
    PaymentErrorStatus["Resolved"] = "Resolved";
    PaymentErrorStatus["Ignored"] = "Ignored";
    PaymentErrorStatus["Escalated"] = "Escalated";
    PaymentErrorStatus["Closed"] = "Closed";
    PaymentErrorStatus["Reopened"] = "Reopened";
})(PaymentErrorStatus || (exports.PaymentErrorStatus = PaymentErrorStatus = {}));
var ErrorTAction;
(function (ErrorTAction) {
    ErrorTAction["Other"] = "";
})(ErrorTAction || (exports.ErrorTAction = ErrorTAction = {}));
//# sourceMappingURL=error.js.map